import {
    DashboardState,
    DashboardProducts,
    DashboardEarnedProducts,
    Earnings
} from '../reducers/dashboard';
import {safelyToJS} from './utils';

export const selectDashboard = (state): DashboardState => state.get('dashboard').toJS();

export const selectEarnedProducts = (state): DashboardEarnedProducts =>
    safelyToJS(state.getIn(['dashboard', 'earnedProducts']));

export const selectProducts = (state): DashboardProducts =>
    safelyToJS(state.getIn(['dashboard', 'products']));

export const selectEarnings = (state): Earnings =>
    safelyToJS(state.getIn(['dashboard', 'earnings']));
